import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  marketValueView: {
    alignItems: 'flex-end',
  },
});
